import { AuthError } from 'firebase/auth';

import { getLocaleFromCookie, getMessages } from '@/i18n/get-messages';

type FirebaseCatalog = (typeof import('../../messages/en.json'))['firebase']['errors'];

export const UserOnlyErrorCodes = [
  'auth/user-not-found',
  'auth/weak-password',
  'auth/email-already-in-use',
  'auth/invalid-email',
  'auth/wrong-password',
  'auth/invalid-phone-number',
  'auth/missing-phone-number',
  'auth/quota-exceeded',
  'auth/cancelled-popup-request',
  'auth/popup-blocked',
  'auth/popup-closed-by-user',
  'auth/invalid-user-token',
  'auth/user-token-expired',
  'auth/network-request-failed',
  'auth/too-many-requests',
  'auth/token-expired',
  'auth/token-revoked',
  'auth/invalid-password',
  'auth/email-already-exists',
  'auth/phone-number-already-exists',
  'auth/invalid-login-credentials',
  'auth/invalid-credential',
];

const locales: Record<string, FirebaseCatalog> = {};

async function getFirebaseCatalog() {
  const locale = getLocaleFromCookie();
  if (locales[locale]) return locales[locale];

  const messages = await getMessages(locale);
  locales[locale] = messages.firebase.errors;
  return locales[locale];
}

export async function getUserMessage({ code, message }: AuthError) {
  const messages = await getFirebaseCatalog();

  if (UserOnlyErrorCodes.includes(code)) {
    const normalizedCode = code.replace(/^auth\//, '');
    return messages.auth[normalizedCode as keyof (typeof messages)['auth']] || message;
  }

  return messages.fallback;
}

export function shouldLogErrorMessage({ code }: AuthError) {
  return !UserOnlyErrorCodes.includes(code);
}

export async function getMessage({ code, message }: AuthError) {
  const messages = await getFirebaseCatalog();
  const normalizedCode = code.replace(/^auth\//, '');
  return messages.auth[normalizedCode as keyof (typeof messages)['auth']] || message;
}
